import { Link } from 'react-router-dom';
import cn from 'classnames';

import GlyphBack from '@/assets/icons/glyph_back.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import styles from './SidebarBackButton.module.scss';

export interface SidebarBackButtonProps {
    /** Title/label for the back button */
    title: string;
    /** URL to navigate to */
    href: string;
    /** Additional CSS class */
    className?: string;
}

export default function SidebarBackButton(props: SidebarBackButtonProps) {
    const { title, href, className } = props;

    return (
        <Link key="navigationBack" to={href} className={cn(styles.backButtonContainer, className)}>
            <SvgIcon
                icon={GlyphBack}
                className={styles.backIcon}
                color="var(--color-success-fill)"
            />
            <div className={styles.backButtonTextWrapper}>{title}</div>
        </Link>
    );
}
